import {
  TabPanel as HuiTabPanel,
  TabPanelProps as HuiTabPanelProps,
} from '@headlessui/react';
import { FC } from 'react';

export type TabPanelProps = HuiTabPanelProps;

export const TabPanel: FC<TabPanelProps> = ({ children, ...props }) => (
  <HuiTabPanel {...props}>{children}</HuiTabPanel>
);
